export const getMessageTimeSheetType = (offType: string): string => {
  const TIME_SHEET_TYPES: { [key: string]: { vi: string } } = {
    'Off_P_0.5': {
      vi: 'Nghỉ có lương (0.5 ngày)'
    },
    Off_P: {
      vi: 'Nghỉ có lương (1 ngày)'
    },
    'Off_U_0.5': {
      vi: 'Nghỉ không lương (0.5 ngày)'
    },
    Off_U: {
      vi: 'Nghỉ không lương (1 ngày)'
    },
    Off_S: {
      vi: 'Nghỉ ốm BHXH'
    },
    Off_SP: {
      vi: 'Nghỉ đặc biệt'
    },
    Off_M: {
      vi: 'Nghỉ thai sản'
    }
  }
  return TIME_SHEET_TYPES[offType] ? TIME_SHEET_TYPES[offType].vi : '---'
}
